import type { UsedStatusType } from '@/api/common/data.d';
import type { FieldFunctionalTypeEnum } from '@/pages/contactManage/fieldSettings/data';

/** 分层列表  - 声明 */
export interface SegmentsListItem {
  /** 是否可编辑 */
  canEdit: boolean;
  /** 主键ID */
  id: number;
  /** 名称 */
  tag: string;
  /** 上次保存时间 */
  updatedAt: string;
  /** 预估订阅人数 */
  subscriptionCount: number;
  /** 同步时间 */
  statisticsTime: string;
  /** 同步状态 0 -同步完成 1 - 同步中*/
  isCount: number;
  /** 是否内置条件 */
  isBulitin: boolean;
  // 获取列表操作项被其它信息引用进而禁用状态及信息 - 类型
  quotaStatus?: UsedStatusType[];
  /** 分层规则是否带有被删除的引用信息 true: 正常  false：存在被删除的内容 */
  isNormal: boolean;
}

/** 内置分层列表  - 声明 */
export interface BuiltInSchemeListItem {
  id: number;
  nameZh: string;
  nameEn: string;
  descZh: string;
  descEn: string;
  segmentNum: number;
  /** 统计时间 */
  statisticsTime: string;
  updatedTime: string;
  loading: boolean;
  disabled: boolean;
  /** 提升百分比 */
  percentage: string;
  /** 提升描述 */
  percentageDescZh: string;
  percentageDescEn: string;
  /** 适用场景 */
  scenarioZh: string;
  scenarioEn: string;
}

/** 分层配置 - 条件  - 声明 */
interface LanguageIF {
  'zh-CN': string;
  'en-US': string;
}

// 第三个输入框 - 输出的规则类型
export type FieldType =
  | 'enum'
  | 'date'
  | 'datetime'
  | 'string'
  | 'int'
  | 'drop down'
  | 'empty';
export enum FieldTypeEnum {
  /** 枚举 - select */
  ENUM = 'enum',
  /** 时间选择 */
  DATE = 'date',
  /** 时间选择 */
  DATETIME = 'datetime',
  /** 字符串 */
  STRING = 'string',
  /** 数字 */
  INT = 'int',
  /** 下拉 - 多选 */
  DROP_DOWN = 'drop down',
  /** 空 */
  EMPTY = 'empty',
}

// 分组
export type GroupType =
  | 'tag'
  | 'from'
  | 'segment'
  | 'customField'
  | 'email_interaction'
  | 'user_journey_group';
export enum GroupTypeEnum {
  /** 标签 */
  TAG = 'tag',
  /** api */
  FROM = 'from',
  /** 自定义字段 */
  CUSTOM_FIELD = 'customField',
  /** 分层规则 */
  SEGMENT = 'segment',
  /** 联系人参与度 */
  CONTACT_ENGAGEMENT = 'email_interaction',
  /** 用户旅程 */
  USER_JOURNEY_GROUP = 'user_journey_group',
  // whatsapp
  WHATSAPP_CAMPAIGN = 'whatsapp_interaction',
  /** 测试玩家状态 */
  TESTER_STATUS = 'tester',
}

export interface ConditionsListIF {
  /** 名称 */
  fieldLabel: LanguageIF;
  /** 字段名 - 不唯一 */
  fieldName: string;
  /** 查询的表名 */
  datasource: string;
  /** 当前协议是否开启 */
  isValid: boolean;
  /** 第三个输入，选择 数据类型 */
  fieldType: FieldType;
  /** 大于，小于，等于 */
  filterOperator:
    | {
        entry: string;
        text: LanguageIF;
        value: string;
      }[]
    | null;
  /** 当fieldType 等于 enum 时，使用 */
  filterOption:
    | {
        text: LanguageIF;
        tooltip: LanguageIF | null;
        value: string;
      }[]
    | null;
  /** 分组 */
  group: GroupType;
  /** 第三个输入框 校验规则 */
  inputLimit: {
    rule: any;
    tip: LanguageIF;
    unit: LanguageIF;
  } | null;
  /** 特殊逻辑 - 是否显示时间段选择 */
  isShowDateOption?: boolean;
  /** 字段名 - 唯一 */
  key: string;
  /** 第三个输入框  placeholder */
  placeholder: LanguageIF | null;
  /** 功能类型 */
  functionalType?: FieldFunctionalTypeEnum;
  /** 标题 */
  title?: string;
}

// 全量分层列表数据类型
export interface AllSegmentItem {
  segmentId: number;
  segmentName: string;
}

export enum WhatsAppInteractionTime {
  // 7天
  sevenDay = '7',
  // 30天
  thirtyDay = '1',
  // 90天
  ninetyDay = '3',
}
